import { vars } from "@common/styles";
import styled from "styled-components";

import BaseHeading from "../../../common/components/Heading/Heading";

export const Administration = styled.div`
  position: relative;
`;

export const Heading = styled(BaseHeading)`
  margin-left: 2.8rem;
  cursor: default;
`;

export const FreeAppBadge = styled.div`
  border-radius: 16px;
  padding: 1px 6px 3px;
  background-color: ${vars.colors.green};

  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: ${vars.colors.black};

  margin-left: 0.4rem;
`;
